/**
 * MN cart notification — brand layer only (isolated from stock Dawn files).
 * Stock stays untouched: cart-notification.liquid, cart-notification-button.liquid,
 * cart-notification.js, component-cart-notification.css.
 */
(function () {
  var ARROW_HTML =
    '<span class="button__arrow svg-wrapper" aria-hidden="true">' +
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-arrow" viewBox="0 0 14 10">' +
    '<path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"/>' +
    '</svg></span>';

  function panel() {
    return document.getElementById('cart-notification');
  }

  function ensureHiddenOnLoad() {
    var el = panel();
    if (!el) return;
    el.classList.remove('active', 'animate');
  }

  function ensureArrow(el) {
    if (!el || el.querySelector('.button__arrow')) return;
    var labelText = (el.textContent || '').trim();
    if (!el.querySelector('span') && labelText) {
      el.textContent = '';
      var span = document.createElement('span');
      span.textContent = labelText;
      el.appendChild(span);
    }
    el.insertAdjacentHTML('beforeend', ARROW_HTML);
  }

  function enhance() {
    var root = document.querySelector('cart-notification');
    if (!root) return;

    var viewCart = root.querySelector('#cart-notification-button');
    if (viewCart) {
      viewCart.classList.add('button--on-light');
      ensureArrow(viewCart);
    }

    var checkout = root.querySelector('#cart-notification-form [name="checkout"]');
    ensureArrow(checkout);

    var continueBtn = root.querySelector('.cart-notification__links > button[type="button"]');
    if (continueBtn) {
      continueBtn.classList.add('cart-notification__continue', 'underlined-link');
      continueBtn.classList.remove('button-label');
    }
  }

  function forceClose(host) {
    var el = panel();
    if (el) el.classList.remove('active');
    if (host && typeof host.close === 'function') {
      try {
        host.close();
      } catch (e) {
        /* ignore */
      }
    }
    document.body.removeEventListener('click', host && host.onBodyClick);
  }

  function bindCloseDelegation(host) {
    if (!host || host.__mnCloseBound) return;
    host.__mnCloseBound = true;

    host.addEventListener('click', function (evt) {
      var btn = evt.target.closest('button[type="button"]');
      if (!btn || !host.contains(btn)) return;
      evt.preventDefault();
      forceClose(host);
    });
  }

  function patchNullSafeSections(Ctor) {
    var proto = Ctor.prototype;
    if (proto.__mnNullSafeSections) return;
    proto.__mnNullSafeSections = true;

    var originalGet = proto.getSectionInnerHTML;
    proto.getSectionInnerHTML = function getSectionInnerHTML(html, selector) {
      if (!html) return '';
      try {
        if (typeof originalGet === 'function') {
          var parsed = originalGet.call(this, html, selector);
          return parsed == null ? '' : parsed;
        }
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector || '.shopify-section');
        return el ? el.innerHTML : '';
      } catch (e) {
        console.error('[mn-cart-notification] getSectionInnerHTML', e);
        return '';
      }
    };

    var originalRender = proto.renderContents;
    proto.renderContents = function renderContents(parsedState) {
      try {
        if (typeof originalRender === 'function') {
          originalRender.call(this, parsedState);
        }
      } catch (e) {
        console.error('[mn-cart-notification] renderContents', e);
        if (!this.notification) this.notification = panel();
        if (typeof this.open === 'function') this.open();
      }
      enhance();
    };
  }

  function init() {
    ensureHiddenOnLoad();

    var host = document.querySelector('cart-notification');
    bindCloseDelegation(host);

    var cartCtor = customElements.get('cart-notification');
    if (cartCtor) {
      patchNullSafeSections(cartCtor);
    } else {
      customElements.whenDefined('cart-notification').then(function () {
        patchNullSafeSections(customElements.get('cart-notification'));
      });
    }

    enhance();

    if (host && typeof MutationObserver !== 'undefined') {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          enhance();
        });
      }).observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
